import * as React from 'react';

import { 
    Button, 
    Box, 
    Typography, 
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

import { Confirmation, InputDialog } from '../utils';
import { TokenValidator, CONST, LoggerUtils, SimpleValidators } from '../../utils';
import { Parts, Logger, Candid, Orders} from '../../controllers';
import TrackingWorkspace from '../trackStations/internal/trackingWorkspace';
import useLegacyAction,{requireLegacySuccess} from '../trackStations/internal/legacyAction';

export default function Main(){
    return <TrackingWorkspace screen='QA_INSPECTION' renderLegacy={({order,onBusy})=><LegacyOrderReader key={order?.orderNumber||'legacy'} initialOrder={order} onBusy={onBusy}/>}/>;
}
export function LegacyOrderReader({AreaInfo,initialOrder,onBusy}) {
    const runLegacy=useLegacyAction(onBusy,()=>({order:selected}));

    const [order, setOrder] = React.useState('');
    const [selected, setSelected] = React.useState('');
    const [parts, setParts] = React.useState([]);
    const [info, setInfo] = React.useState([]);
    const [errors, setErrors] = React.useState([]);
    const [errorLog, setErrorLog] = React.useState('');

    const [co, isCo] = React.useState(false);
    const [coType, setCoType]  = React.useState(0);
    const [coNumber, setCoNumber] = React.useState('');
    const [coData, setCoData] = React.useState({
        dhr: 0,
        counter : 0
    })

    //UI Confirmations
    const [error, showError] = React.useState(false);
    const [processing, showProcessing] = React.useState(false);
    const [errorInput, showErrorInput] = React.useState(false);

    //CO-UI Confirmations
    const [coTypeUi, showCoTypeUi] = React.useState(false);
    const [coProxes, showCoProxes] = React.useState(false);

    const handleFetch = runLegacy(async(e,scannedOrder=order) => {
        e.preventDefault();
        isCo(false);
        setParts([]);setSelected('');setInfo([]);setErrors([]);

        const status = "QAP Init";
        const result = await Parts.GetTracking("", scannedOrder, status);

        if(!result.success){
            if(result.message){
                alert(result.message);
            }else{
                alert('Error while fetching order information')
            }
            return;
        }

        if(result.result.length < 1){

            const response = await Candid.GetTracingReportByOrder(scannedOrder);

            if(response === undefined){
                alert('Error al leer Orden');
                return;
            }

            if(response.success && response.found){

                isCo(true);
                setParts([]);
                setSelected(scannedOrder);
                setCoNumber(response.result.case_serial);
                return;
            }

            alert('Orden escaneada no valida');
        }

        const orderInfo = await Parts.GetDetailFullByOrder(scannedOrder);

        setParts(result.result);
        setInfo(orderInfo.result);
        setSelected(scannedOrder);
        setOrder('');
    });

    const initialLoaded=React.useRef(false),initialFetch=React.useRef(handleFetch);
    initialFetch.current=handleFetch;
    React.useEffect(()=>{
        if(initialOrder&&!initialLoaded.current){initialLoaded.current=true;initialFetch.current({preventDefault:()=>{}},initialOrder.orderNumber);}
    },[initialOrder]);

    const handleProcessing = runLegacy(async() => {
        const targetStatus = await handleOrderAnalisys();
        var validParts = [];
        parts.forEach(x => validParts.push(x));

        if(targetStatus != 'MRB'){
            info.forEach(x => {
                if(x.status_id === 36){
                    const cycle = {
                        id : x.id
                    };
                    validParts.push(cycle);
                }
            });
        }
        

        const token = '';
        
        for(const part of validParts){
            const hasError = errors.includes(part.id);
            const logType = hasError ? 'Error' : 'Update'
            const logTitle = `Tracking Station QAP : ${logType}`
            const logInfo = hasError ? errorLog : 'Part processed through area successfully'

            const status = hasError ? 'QAP Error' : targetStatus;
            const payload = {
                id          : part.id,
                status      : status,
            }

            const log = await LoggerUtils.PayloadCreator( logType, logTitle, logInfo);
            const response = await Parts.UpdateStatus(token, {...payload,audit:log});
            requireLegacySuccess(response);
        }

        showProcessing(false);
        setParts([]);
        setErrors([]);
    },{write:true});

    const handleError = async(e) => {
        var delta = [...errors];
        const value = parseInt(e.target.value);
        
        if(e.target.checked){
            delta.push(value);
        }else{
            delta = delta.filter(x => x != value)
        }
        
        setErrors(delta);
        setErrorLog('');
    }

    const EvaluateError = async() => {
        if(errors.length > 0){
            showErrorInput(true);
            return;
        }

        showProcessing(true);
    }

    const handleOrderAnalisys = async() => {
        if(errors.length === parts.length){
            return '';
        }

        const statuses = await SimpleValidators.Uniques(info, 'status_id');
        const min = statuses.sort((a, b) => {return a - b})[0];

        if (min < 33 || errors.length > 0){
            return 'MRB';
        }


        return 'Packaging Init';
    }

    const handleCounters = async(e) => {
        setCoData({...coData, [e.target.id]:parseInt(e.target.value)})
    }

    const handleCoType = async(type) => {
        setCoType(type);
        showCoTypeUi(false);
        showCoProxes(true);
    }

    const handleCoProcessing = runLegacy(async() =>{
        showCoProxes(false);

        const payload = {
            order : coNumber,
            data : {
                area : {
                    name : 'QAP',
                    id : coType === 0 ? 8 : 7.5,
                },
                number : selected,
                counter : coData
            }
        }

        const response = await Candid.CreateTracing(payload);
        requireLegacySuccess(response);

        if(response == undefined){
            alert('Error Processing Order. \nPlease, try again');
            return;
        }

        if(!response.success){
            alert('Processing Order fail. \nPlease, try again');
            return;
        }

        isCo(false);
        setOrder('');
        setCoType(0);
        alert('Order Processed successfully');
    },{write:true});

    return(
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: 2
            }}
        >
            <Confirmation 
                open={error}
                onClose={() => showError(false)}
                onConfirm={() => showError(false)}
                title={'Wrong Scan'}
                msg={'Please Scan the numeric barcode (Order ID)'}
                info={true}
            />

            <InputDialog 
                open={errorInput}
                closer={() => showErrorInput(false)}
                fetcher={setErrorLog}
                action={ () => showProcessing(true)}
                title={'Error Description'}
                msg={'Enter error description in the field below'}
            />

            <Confirmation 
                open={processing}
                onClose={() => showProcessing(false)}
                onConfirm={handleProcessing}
                title={'Confirmation'}
                msg={'The parts will be updated with the given input'}
                info={false}
            />

            <Confirmation 
                open={coProxes}
                onClose={() => showCoProxes(false)}
                onConfirm={handleCoProcessing}
                title={'Confirmation'}
                msg={'The parts will be updated with the given input'}
                info={false}
            />

            <Confirmation 
                open={coTypeUi}
                onClose={() => handleCoType(0)}
                onConfirm={() => handleCoType(1)}
                title={'MRB'}
                msg={'Put pieces on hold in MRB'}
                cancelTxt='No'
                confirmTxt='Yes'
            />

            <br/>

            <Typography variant='h5'>
                Scanner Module
            </Typography>
            <Box 
                sx={{ mt: 1 }} 
                component='form'
                onSubmit={handleFetch}
            >
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="ESCANEA :  Order Id"
                    id="order"
                    name="order"
                    autoFocus
                    value={order}
                    onChange={e => setOrder(e.target.value)}
                />
            </Box>

            <Divider 
                sx={{
                    marginTop:1,
                    minWidth:'95vw',
                    borderColor:CONST.Colors.Primary.Main
                }}
            />

            {parts.length > 0 && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            padding: 2,
                        }}
                    >
                        <Typography variant='h6'>
                            Order ID:{selected}
                        </Typography>
                        <Button
                            color='success'
                            variant='contained'
                            onClick={EvaluateError}
                        >
                            Process Parts
                        </Button>
                    </Box>
                        
                    <Divider 
                        sx={{
                            minWidth:'95vw',
                            borderColor:CONST.Colors.Primary.Main
                        }}
                    />

                    <TableContainer sx={{mt:2}}>
                    <Table sx={{ minWidth: '90vw' }} aria-label="simple table">
                        <TableHead>
                        <TableRow >
                            <TableCell >TAG</TableCell>
                            <TableCell  align="center">TYPE</TableCell>
                            <TableCell  align="center">STEP</TableCell>
                            <TableCell  align="center">SIDE</TableCell>
                            <TableCell  align="center">ERROR</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {parts.map((row) => (
                            <TableRow
                            key={row.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">{row.tag}</TableCell>
                                <TableCell align="center">{row.data_general.type}</TableCell>
                                <TableCell align="center">{row.step}</TableCell>
                                <TableCell align="center">{row.side == 1 ? 'Upper' : 'Lower' }</TableCell>
                                <TableCell align="center">
                                    <Checkbox  color='secondary' value={row.id} onChange={handleError}/>
                                </TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                    </TableContainer>
                </Box>
            )}

            {parts.length <= 0 && co && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            padding: 2,
                        }}
                    >
                        <Typography variant='h6' sx={{alignContent:'center'}}>
                            Candid Order || Case ID: {coNumber}
                        </Typography>
                        
                        <Button
                            color='success'
                            variant='contained'
                            onClick={() => showCoTypeUi(true)}
                        >
                            Process Parts
                        </Button>
                        
                    </Box>
                        
                    <Divider 
                        sx={{
                            minWidth:'95vw',
                            borderColor:CONST.Colors.Primary.Main
                        }}
                    />

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            gap: 2
                        }}
                    >
                        {/* <TextField
                            hidden
                            disabled={AreaInfo.data.candid_id > 1}
                            margin="normal"
                            type='number'
                            required
                            fullWidth
                            label="Enter DHR Counter"
                            id="dhr"
                            name="dhr"
                            autoFocus
                            value={coData.dhr}
                            onChange={e => handleCounters(e)}
                        /> */}

                        <TextField
                            type='number'
                            margin="normal"
                            required
                            fullWidth
                            label="Enter Counter"
                            id="counter"
                            name="counter"
                            value={coData.counter}
                            onChange={e => handleCounters(e)}
                        />
                    </Box>
                    
                </Box>
            )}

        </Box>
    );
}
